import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
import { Card } from '../ui/Card';
import { PhotoCarousel } from './PhotoCarousel';
interface ResolvableReport {
  id: string;
  type: string;
  emoji: string;
  description: string;
  photos: string[];
  isResolved: boolean;
}
interface ResolvableReportCardProps {
  report: ResolvableReport;
  isExpanded: boolean;
  onToggle: () => void;
  onResolveToggle: () => void;
}
export function ResolvableReportCard({
  report,
  isExpanded,
  onToggle,
  onResolveToggle
}: ResolvableReportCardProps) {
  return <motion.div animate={{
    backgroundColor: report.isResolved ? 'rgb(240, 253, 244)' : 'rgb(255, 255, 255)'
  }} transition={{
    duration: 0.3
  }} className="rounded-xl overflow-hidden border border-gray-200" data-id="element-239">
      <button onClick={onToggle} className="w-full p-6 flex items-center justify-between hover:bg-gray-50/50 transition-colors touch-manipulation" data-id="element-240">
        <div className="flex items-center gap-4 flex-1 text-left" data-id="element-241">
          <span className="text-3xl" data-id="element-242">{report.emoji}</span>
          <div className="flex-1 min-w-0" data-id="element-243">
            <span className="text-lg font-semibold text-navy block" data-id="element-244">
              {report.type}
            </span>
            {report.isResolved && <span className="text-base text-green-700 flex items-center gap-2 mt-2" data-id="element-245">
                <Check className="w-5 h-5" data-id="element-246" />
                Risolta
              </span>}
          </div>
        </div>
        <motion.div animate={{
        rotate: isExpanded ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-247">
          <ChevronDown className="w-6 h-6 text-gray-400" data-id="element-248" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-249">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-250">
            <div className="px-6 pb-6 pt-2 border-t border-gray-100 space-y-5" data-id="element-251">
              {/* Descrizione */}
              <div data-id="element-252">
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-253">
                  Descrizione
                </p>
                <p className="text-base text-gray-700 leading-relaxed bg-gray-50 p-4 rounded-lg" data-id="element-254">
                  {report.description}
                </p>
              </div>

              {/* Foto */}
              {report.photos.length > 0 && <div data-id="element-255">
                  <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3" data-id="element-256">
                    Foto
                  </p>
                  <PhotoCarousel photos={report.photos} data-id="element-257" />
                </div>}

              {/* Checkbox Risolta */}
              <div className="pt-2" data-id="element-258">
                <button onClick={e => {
              e.stopPropagation();
              onResolveToggle();
            }} className="flex items-center gap-4 w-full p-4 rounded-lg hover:bg-gray-50 transition-colors touch-manipulation" data-id="element-259">
                  <motion.div animate={{
                scale: report.isResolved ? 1 : 1,
                backgroundColor: report.isResolved ? 'rgb(34, 197, 94)' : 'rgb(255, 255, 255)'
              }} className="w-7 h-7 rounded border-2 border-gray-300 flex items-center justify-center flex-shrink-0" data-id="element-260">
                    {report.isResolved && <motion.div initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} transition={{
                  type: 'spring',
                  stiffness: 500,
                  damping: 25
                }} data-id="element-261">
                        <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-262" />
                      </motion.div>}
                  </motion.div>
                  <span className="text-base font-semibold text-navy" data-id="element-263">
                    Segna come risolta
                  </span>
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}